/**
 * Konvertiert ein reines Datum ('YYYY-MM-DD', z. B. aus <input type="date">) in
 * das vom pm-api erwartete ISO-8601-datetime. Das Task-Schema validiert
 * abschluss_start/abschluss_end mit zod .datetime() — ein reines Datum ergibt
 * 400 ("Invalid datetime").
 *
 * Bewusst per String-Append auf UTC-Mitternacht (kein dayjs/Date), um die
 * Zeitzonen-Falle zu vermeiden: new Date('2026-06-08') bzw. dayjs(...).toISOString()
 * verschiebt bei positivem UTC-Offset auf den Vortag. Die pm-api-Spalte ist DATE,
 * also zaehlt nur der Datumsteil — UTC-Mitternacht haelt ihn stabil.
 */
export function toApiDatetime(date: string | null | undefined): string | null {
  if (!date) return null;
  return `${date}T00:00:00.000Z`;
}
